// src/components/insights/RelatedArticles.jsx

import { Link } from "react-router-dom";
import { insights } from "../../content/insights";

function getRelatedArticles(article, insights) {
  // 1️⃣ MANUAL (PRIORITAT)
  if (article.related && article.related.length > 0) {
    return article.related
      .map(slug => insights.find(a => a.slug === slug))
      .filter(Boolean);
  }

  // 2️⃣ TAGS (INTEL·LIGENT)
  if (article.tags && article.tags.length > 0) {
    const relatedByTags = insights
      .filter(a => a.slug !== article.slug && a.tags)
      .map(a => {
        const overlap = a.tags.filter(tag =>
          article.tags.includes(tag)
        ).length;

        return { article: a, score: overlap };
      })
      .filter(x => x.score > 0)
      .sort((a, b) => b.score - a.score)
      .map(x => x.article)
      .slice(0, 3);

    if (relatedByTags.length > 0) return relatedByTags;
  }

  // 3️⃣ CATEGORIA + RECÈNCIA (FALLBACK)
  return insights
    .filter(
      a =>
        a.slug !== article.slug &&
        a.meta.category === article.meta.category
    )
    .sort(
      (a, b) =>
        new Date(b.meta.publishedAt) - new Date(a.meta.publishedAt)
    )
    .slice(0, 3);
}

function RelatedArticles({ article }) {
  const related = getRelatedArticles(article, insights);

  if (!related || related.length === 0) return null;

  return (
    <div className="related">
      <h3 className="related-title">Related articles</h3>

      {related.map(a => (
        <Link
          key={a.slug}
          to={`/insights/${a.slug}`}
          className="related-link"
        >
          {a.meta.title}
        </Link>
      ))}
    </div>
  );
}

export default RelatedArticles;